import { render, staticRenderFns } from "./DoctorInfo.vue?vue&type=template&id=cba489aa&"
import script from "./DoctorInfo.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DoctorInfo.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cba489aa')) {
      api.createRecord('cba489aa', component.options)
    } else {
      api.reload('cba489aa', component.options)
    }
    module.hot.accept("./DoctorInfo.vue?vue&type=template&id=cba489aa&", function () {
      api.rerender('cba489aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/info/pressa/components/DoctorInfo.vue"
export default component.exports